import React from 'react';
import { AlertTriangle, ArrowRight, CreditCard } from 'lucide-react';
import { UserProfile } from '../types';
import { HideOnPlayStore } from './HideOnPlayStore';

interface GracePeriodBannerProps {
  user: UserProfile | null;
  onOpenPaywall: () => void;
}

export default function GracePeriodBanner({ user, onOpenPaywall }: GracePeriodBannerProps) {
  if (!user || user.isMasterUser) return null;
  if (user.subscriptionStatus !== 'past_due') return null;

  const remainingDays = user.accessEndsAt
    ? Math.max(
        1,
        Math.ceil((new Date(user.accessEndsAt).getTime() - Date.now()) / (1000 * 60 * 60 * 24))
      )
    : 7;

  return (
    <div className="w-full bg-linear-to-r from-amber-600 via-amber-500 to-yellow-500 text-zinc-950 px-4 py-2.5 shadow-md flex items-center justify-between gap-3 text-xs sm:text-sm animate-in fade-in duration-300">
      <div className="flex items-center gap-2 sm:gap-3 flex-1 min-w-0">
        <div className="p-1.5 bg-black/15 rounded-xl shrink-0">
          <AlertTriangle className="h-4 w-4 sm:h-5 sm:w-5 text-zinc-950 animate-pulse" />
        </div>
        <p className="font-semibold truncate">
          <span className="font-black uppercase tracking-wider mr-1.5 text-zinc-950">
            Aviso de Renovação:
          </span>
          <span>Identificamos uma falha no débito do cartão. Seu acesso continua </span>
          <span className="font-black underline decoration-black decoration-2 underline-offset-2">
            100% liberado por mais {remainingDays} {remainingDays === 1 ? 'dia' : 'dias'}
          </span> enquanto realizamos nova tentativa.
        </p>
      </div>

      <HideOnPlayStore>
        <button
          type="button"
          onClick={onOpenPaywall}
          className="shrink-0 bg-zinc-950 text-white hover:bg-zinc-900 font-black text-xs px-3.5 py-1.5 rounded-xl transition-all shadow-sm hover:scale-105 active:scale-95 flex items-center gap-1.5 cursor-pointer"
        >
          <CreditCard className="h-3.5 w-3.5 text-amber-400" />
          <span>Regularizar / Pagar no PIX</span>
          <ArrowRight className="h-3.5 w-3.5" />
        </button>
      </HideOnPlayStore>
    </div>
  );
}
